import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import TwoColumnLayOut from "../../layouts/two-columns/two-column-layout";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { retrieveProductDetails } from "../../redux/slice/products/product-details-slice";
import { RootState, useAppDispatch } from "../../redux/store";
import LoadingComp from "../../components/re-usable/loading/loading";

const OnlineUniversityCertificates = () => {
  const dispatch = useAppDispatch();
  const path = "Education%2FOnline-University-Certificates";
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const { ProductDetailsData } = useSelector((state: RootState) => state.ProductDetails);

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
    dispatch(retrieveProductDetails(`certificates`));
  }, [dispatch]);

  // Page published check
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <TwoColumnLayOut breadcrumbPath={path} isBreadcrumbpath={false} showAds={true}>
        <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.description }}></div>
        <div></div>
        {ProductDetailsData[0]?.productInfoItemsList?.map((item, index) => {
          return (
            <div className="info-listing-section">
              <div className="container il-container">
                <div className="il-img-wrapper col-lg-3 col-md-12 text-center">
                  <img src={item.imageUrl} className="il-img" alt="" />
                </div>
                <div className="il-content-wrapper">
                  <h2 className="h2">{item.name}</h2>
                  <p className="il-content-intro" dangerouslySetInnerHTML={{ __html: item.shortDescription }}></p>
                </div>
                <div className="il-side-wrapper">
                  <div className="il-side"></div>
                  <div className="il-btn-wrapper">
                    <a href={`/products/${item.nodeName}`} className="btn btn-default">
                      Learn More
                    </a>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.councilDescription }}></div>
      </TwoColumnLayOut>
    </>
  );
};

export default OnlineUniversityCertificates;
